<ng-container *ngVar="changeLogQuery.selectActive() | async as log">
  @if (showAnalyticsSection$ | async) {
    <div class="mb-12 mt-8 grid grid-cols-5 gap-7.5">
      <div
        class="col-span-2 flex h-28 items-center justify-around rounded border border-aux-gray-dark py-3"
      >
        <div class="flex flex-col justify-center rounded-l px-4 pr-1">
          <div class="font-bold text-aux-black">
            Change Log
            <br />
            Running Total ($)
          </div>
        </div>
        <div class="h-full bg-aux-gray-dark" style="width: 1px"></div>
        <div class="flex items-center justify-center space-x-2 rounded-r px-4 tabular-nums">
          <div class="flex items-center justify-center space-x-2 rounded-r px-4">
            @if (log) {
              <div class="text-lg font-bold text-aux-gray-darkest">
                {{ log.clis_total }}
              </div>
            }
          </div>
        </div>
      </div>
      <div class="col-span-3 grid grid-cols-5 rounded border p-4">
        <div class="h-18 flex items-center justify-center border-r font-bold">
          Change by
          <br />
          Cost Type
        </div>
        @if (log) {
          <div class="col-span-4 flex flex-col justify-between pl-5 tabular-nums">
            <div class="flex h-6 w-full text-xs font-bold text-white">
              @if (log.services_percent; as percentage) {
                <div
                  class="rounded-l bg-aux-blue-dark px-2 py-1 text-center"
                  [ngStyle]="{ flexGrow: percentage }"
                  [ngClass]="{ 'rounded-r': percentage === 100 }"
                >
                  {{ percentage }}%
                </div>
              }
              @if (log.investigator_fee_percent; as percentage) {
                <div
                  class="bg-aux-gray-dark-100 px-2 py-1 text-center"
                  [ngStyle]="{ flexGrow: percentage }"
                  [ngClass]="{ rounded: percentage === 100 }"
                >
                  {{ percentage }}%
                </div>
              }
              @if (log.pass_thru_percent; as percentage) {
                <div
                  class="rounded-r bg-aux-gray-dark px-2 py-1 text-center"
                  [ngStyle]="{ flexGrow: percentage }"
                  [ngClass]="{ 'rounded-l': percentage === 100 }"
                >
                  {{ percentage }}%
                </div>
              }
            </div>
            <div class="grid grid-cols-3">
              <div>
                <div class="mb-2 mr-1 flex items-center justify-center">
                  <div class="mr-2 h-4 w-4 rounded-full bg-aux-blue-dark"></div>
                  <div class="text-xs">Services</div>
                </div>
                <div class="flex items-center justify-center text-sm font-bold">
                  {{ log.services_total }}
                </div>
              </div>
              <div>
                <div class="mb-2 mr-1 flex items-center justify-center">
                  <div class="mr-2 h-4 w-4 rounded-full bg-aux-gray-dark-100"></div>
                  <div class="text-xs">Investigator</div>
                </div>
                <div class="flex items-center justify-center text-sm font-bold">
                  {{ log.investigator_fees_total }}
                </div>
              </div>
              <div>
                <div class="mb-2 mr-1 flex items-center justify-center">
                  <div class="mr-2 h-4 w-4 rounded-full bg-aux-gray-dark"></div>
                  <div class="text-xs">Pass-through</div>
                </div>
                <div class="flex items-center justify-center text-sm font-bold">
                  {{ log.pass_thru_total }}
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (
    {
      loading: changeLogQuery.selectLoading() | async,
    };
    as obj
  ) {
    @if (obj.loading) {
      <div class="mt-16 flex items-center justify-center text-3xl">
        <!--<div *ngIf="!obj.loading && obj.count === 0">No log found</div>-->
        @if (obj.loading) {
          <div class="spinner my-8"></div>
        }
      </div>
    }
    @if (!obj.loading) {
      @if (changeLogQuery.selectAll() | async) {
        <div class="mb-4 flex flex-wrap items-center gap-4" style="width: 100%">
          <div class="flex space-x-4">
            <div class="ml-1 flex space-x-4">
              <aux-input
                class="w-60"
                placeholder="Search"
                icon="Search"
                iconPosition="left"
                hotKey="/"
                [(ngModel)]="nameFilterValue"
              />
              <div class="flex items-center">
                <div class="mr-2 text-sm">Vendor Contract:</div>
                <aux-vendor-dropdown
                  [vendors]="(vendorsQuery.allVendors$ | async)!"
                  [formControl]="selectedVendor"
                  (onChange)="onVendorSelected($event)"
                />
              </div>
            </div>
            <div class="flex w-min max-w-xl items-center">
              <div class="mr-2 text-sm">Status:</div>
              <ng-select
                id="status"
                class="w-48 text-sm"
                appendTo="body"
                [formControl]="selectedStatus"
                [clearable]="false"
                [searchable]="false"
              >
                <ng-option [value]="''">All</ng-option>
                >
                @for (status of this.statusConstant; track status) {
                  <ng-option [value]="status.value">
                    <div class="flex items-center whitespace-nowrap">
                      <div class="mr-1 h-3 w-3 rounded-full" [ngClass]="status.circleClass"></div>
                      <div [ngClass]="status.textClass">{{ status.text }}</div>
                    </div>
                  </ng-option>
                }
              </ng-select>
            </div>
          </div>
          <div class="my-1 grid grid-flow-col gap-x-1.5">
            <!-- todo??? className="col-span-1" -->
            <aux-export-excel-button
              [gridAPI]="gridAPI"
              [ignoreColsId]="['site_id', 'file_link']"
              [ignoreColsCallback]="getIgnoreCols"
              [excelOptions]="excelOptions"
              pendoTag="cis-log-excel-export-button"
            />
            @if (
              log?.change_log_status === 'STATUS_OPEN' &&
              (changeLogQuery.selectActiveId() | async) !== null
            ) {
              <button class="btn--primary pl-3" type="button" (click)="onAddLine()">
                <aux-icon name="Plus" class="mr-2" />
                Add New
              </button>
            }
            @if (changeLogQuery.selectActiveId() | async) {
              <div class="flex space-x-2">
                <button class="btn--primary" (click)="openUploadModal()">
                  <aux-icon name="Plus" />
                  <span>Upload New CIS Log</span>
                </button>
              </div>
            }
          </div>
        </div>
      }

      <ag-grid-angular
        domLayout="autoHeight"
        class="ag-theme-aux tabular-nums"
        [rowData]="log?.change_log_items || []"
        [gridOptions]="gridOptions"
        [quickFilterText]="nameFilterValue"
        (firstDataRendered)="onGridReady($event)"
        (columnResized)="autoSize()"
        auxStickyGrid
      />
    }
  }
</ng-container>
